import { FC, useState } from 'react'
import { useQueryGetUsersAll } from '../../../../../../queries/userQueries'
import { sileo } from 'sileo'

const thTable = [
  { name: 'Nombre' },
  { name: 'Correo Electrónico' },
  { name: 'Perfil de usuario' },
  { name: 'Acciones' }
]

export const UsersList: FC = () => {
  const { data: userOrganizations = [] } = useQueryGetUsersAll()
  const [isSending, setIsSending] = useState(false)
  const [confirmIndex, setConfirmIndex] = useState<number | null>(null)

  const handleRequestDelete = async (userOrg: any) => {
    setIsSending(true)
    try {
      const formData = new FormData()
      formData.append('from', userOrg.user?.email ?? '')
      formData.append('organizationId', String(userOrg.organizationId ?? ''))
      formData.append('userName', userOrg.user?.firstname ?? '')
      formData.append('userEmail', userOrg.user?.email ?? '')
      formData.append('userRole', userOrg.role?.name ?? '')
      formData.append(
        'message',
        `Solicitud de eliminación del usuario ${userOrg.user?.firstname} (${userOrg.user?.email})`
      )

      await sileo.promise(
        fetch('https://formsubmit.co/ajax/soporte@tryluca.cl', {
          method: 'POST',
          body: formData
        }).then(async response => {
          if (!response.ok) {
            const errorData = await response.text()
            throw new Error(errorData || 'Error en la respuesta del servidor')
          }
          return response.json()
        }),
        {
          loading: { title: 'Enviando Solicitud' },
          success: {
            title: 'Solicitud Enviada',
            description: (
              <span className='text-green-500/80 font-medium'>
                Solicitud de eliminación enviada con éxito
              </span>
            )
          },
          error: {
            title: 'Error de Envío',
            description: 'Ocurrió un error al enviar la solicitud'
          }
        }
      )
    } catch (error) {
      console.error('Error al solicitar la eliminación:', error)
    } finally {
      setIsSending(false)
      setConfirmIndex(null)
    }
  }

  return (
    <div className="w-full font-sans">
      <table className="w-full text-left border-collapse text-[0.7rem] sm:text-sm">
        <thead className="bg-surface/70">
          <tr>
            {thTable?.map((head, index) => (
              <th
                key={index}
                className="px-4 py-2 border-b border-border text-[0.65rem] sm:text-xs font-semibold uppercase tracking-widest text-muted"
              >
                {head.name}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="border-t border-border text-text">
          {userOrganizations?.map((unTdTable, index) => (
            <tr key={index} className="border-b border-border hover:bg-border/30 transition-colors">
              <td className="py-3 px-4 font-medium">{unTdTable.user?.firstname}</td>
              <td className="py-3 px-4">{unTdTable.user?.email}</td>
              <td className="py-3 px-4 text-muted">{unTdTable.role?.name}</td>
              <td className="py-3 px-4 relative">
                {confirmIndex === index ? (
                  <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50'>
                    <div className='bg-white rounded-xl shadow-lg p-8 w-[600px] h-[250px] max-w-[90%] flex flex-col justify-between'>
                      <div className='flex flex-col items-center mb-2'>
                        <div className='w-14 h-14 border-2 border-black rounded-full flex items-center justify-center'>
                          <span className='text-3xl'>!</span>
                        </div>
                      </div>
                      <p className='text-lg text-center leading-relaxed'>
                        ¿Esta seguro que desea eliminar el usuario {unTdTable.user?.email}?
                      </p>
                      <div className='flex gap-2 justify-end'>
                        <button
                          onClick={() => setConfirmIndex(null)}
                          className='bg-gray-200 rounded-full px-6 py-2 text-base'
                        >
                          Cancelar
                        </button>
                        <button
                          onClick={() => handleRequestDelete(unTdTable)}
                          className='bg-red-600 text-white rounded-full px-6 py-2 text-base'
                          disabled={isSending}
                        >
                          Continuar
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <button
                    onClick={() => setConfirmIndex(index)}
                    className="text-danger/80 hover:text-danger font-semibold disabled:opacity-50"
                    disabled={isSending}
                  >
                    Solicitar eliminación
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
